import { render, staticRenderFns } from "./duteDetail.vue?vue&type=template&id=f21ef026&scoped=true&"
import script from "./duteDetail.vue?vue&type=script&lang=js&"
export * from "./duteDetail.vue?vue&type=script&lang=js&"
import style0 from "./duteDetail.vue?vue&type=style&index=0&id=f21ef026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21ef026",
  null
  
)

export default component.exports